<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog'"
    :offsetTop="''"
    :openDialog="isOpen"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <doc-in-create
        @success="createSuccess"
        @deleteSuccess="deleteSuccess"
        @rejectSuccess="rejectSuccess"
        @cxlSuccess="cxlSuccess"
        @cancel="$emit('closeDialog')"
        :id="id"
        :copyFromDocId="copyFromDocId"
      />
    </template>
  </custom-dialog>
</template>

<script>
  import DocInCreate from "../Create";

  export default {
    name: 'create-doc-in-dialog',
    props: ['isOpen', 'id', 'copyFromDocId'],
    components: {
      DocInCreate,
      customDialog: () => import('../../common/custom-dialog.vue'),
    },
    methods: {
      createSuccess(event) {
        this.$emit("success", event);
      },

      deleteSuccess(event) {
        this.$emit("deleteSuccess", event);
      },

      rejectSuccess(event) {
        this.$emit("rejectSuccess", event);
      },

      cxlSuccess(event) {
        this.$emit("cxlSuccess", event);
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/CreateDialog.vue